<template>
    <div>
        <header class="bg-bkg text-black px-6 sm:px-8 py-1 sm:py-2 fixed w-full top-0 z-30 shadow-light dark:shadow-dark dark:bg-dark.bkg dark:text-dark.contentText">
            <div class="container mx-auto">
                <logo-component class="float-left" :display_moto="true" />
                <div class="relative float-right mt-2 sm:mt-0.5">
                    <font-awesome-icon icon="fas fa-bars" class="lg:hidden cursor-pointer" @click="menuOpen = !menuOpen" />
                    <!-- Dropdown Menu -->
                    <nav :class="{'absolute right-0 top-full mt-2 md:mt-0 bg-bkg dark:bg-dark.bkg border border-sepBorder dark:border-dark.sepBorder lg:border-0 rounded shadow-light dark:shadow-dark sm:shadow-none': menuOpen, 'hidden': !menuOpen}" class="lg:static lg:block lg:shadow-none">
                        <div class="flex gap-6 mt-0.5 px-2 lg:px-0 leading-snug lg:leading-none whitespace-nowrap">
                            <!--<button @click="$router.push({ path: '/affiliate'});" class="py-2 hover:text-growth border-0 cursor-pointer text-center">{{ $t('Affiliate') }}</button>-->
                            <button @click="$router.push({ path: '/', query: { open: 'benefits' } });" class="py-2 hover:text-growth border-0 cursor-pointer text-center">{{ $t('benefits') }}</button>
                            <button @click="$router.push({ path: '/', query: { open: 'pricing' } });" class="py-2 hover:text-growth border-0 cursor-pointer text-center">{{ $t('pricing') }}</button>
                            <button @click="$router.push({ path: '/download' });" class="bg-gray-200 dark:bg-dark.panels rounded-lg px-2 py-1.5 hover:text-growth border-0 cursor-pointer text-center">{{ $t('Download') }}</button>
                            <button @mouseover="openSignupOptions = true" @mouseleave="openSignupOptions = false" class="py-2 hover:text-growth font-bold cursor-pointer">{{ $t('sign_up') }}
                                <div class="z-50 absolute mt-2" v-show="openSignupOptions == true">
                                    <div class="mt-3 bg-bkg shadow-light dark:shadow-dark text-black rounded-b p-3 pt-1 text-left dark:bg-dark.bkg dark:text-dark.contentText">
                                        <small class="text-left font-light">{{ $t('account_for') }}</small>
                                        <div class="my-3 mb-4 hover:text-growth" @click="$router.push({ path: '/', query: { open: 'register' } });">{{$t('agency')}}</div>
                                        <div class="hover:text-growth" @click="$router.push({ path: '/', query: { open: 'signup_creator' } });">{{$t('creator')}}</div>
                                    </div>
                                </div>
                            </button>
                            <button @click="$router.push({ path: '/', query: { open: 'login' } });" class="py-2 hover:text-growth font-bold cursor-pointer text-center">{{ $t('log_in') }}</button>
                            <language-picker class="mx-auto mt-1"/>
                            <div @click="toggleDarkMode" class="mx-auto my-2 sm:my-0 cursor-pointer pt-0.5 w-10 text-center text-lg dark:text-dark.contentText rounded-full bg-gray-200 dark:bg-dark.panels ">
                                <font-awesome-icon :icon="icon" />
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </header>
    </div>
</template>

<script setup>
    import logoComponent from "@/components/logo.vue";
    import languagePicker from "@/components/languagePicker.vue";
</script>
<script>
    export default {
        data() {
            return {
                menuOpen: false,
                openSignupOptions: false,
                mode: document.documentElement.classList.contains('dark') ? 'dark' : 'light',
                icon: document.documentElement.classList.contains('dark') ? 'fa-solid fa-sun' : 'fa-solid fa-moon'
            }
        },
        components: {
            logoComponent,
            languagePicker
        },
        methods:{
            toggleDarkMode() {
                this.mode = this.mode === 'light' ? 'dark' : 'light';
                this.icon = this.icon === 'fa-solid fa-moon' ? 'fa-solid fa-sun' : 'fa-solid fa-moon';
                const html = document.documentElement; // Or document.body
                html.classList.toggle('dark');
                localStorage.setItem("darkMode", this.mode.toString() === 'dark');
            }
        }
    }
</script>